import { apiFetch } from './client';

export interface LegalDoc {
  key: 'tos' | 'privacy' | 'disclaimer';
  version: string;
  title: string;
  markdown: string;
}

export interface LegalConsent {
  tos_accepted_at: string | null;
  tos_version: string | null;
}

export interface LegalStatus {
  documents: LegalDoc[];
  currentVersion: string;
  consent: LegalConsent;
  needsConsent: boolean;
}

export const legalApi = {
  getPublicDocuments: () => apiFetch<{ documents: LegalDoc[]; currentVersion: string }>('/api/legal/documents'),
  getStatus: () => apiFetch<LegalStatus>('/api/legal'),
  accept: () =>
    apiFetch<{ ok: boolean; consent: LegalConsent; currentVersion: string }>('/api/legal/accept', {
      method: 'POST',
      body: JSON.stringify({}),
    }),
};
